import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-job-orders",
    templateUrl: "./job-orders.component.html",
    styleUrls: ["./job-orders.component.scss"],
    standalone: false
})
export class JobOrdersComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
